module.exports = __webpack_public_path__ + "img/login_jieyang.47e3af67.png";